import React, {useEffect, useRef, useState} from 'react';
import './supportIdeasSection.scss';

const SupportIdeasSection = () => {
	const [aboutYourself, setAboutYourself] = useState('');
	const [yourIdea, setYourIdea] = useState('');
	const [width, setWidth] = useState(window.innerWidth);

	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);

	const aboutTextareaRef = useRef(null) as any;
	const ideaTextareaRef = useRef(null) as any;

	const autoResizeTextarea = (textarea: any) => {
		textarea.style.height = 'auto';
		textarea.style.height = `${textarea.scrollHeight}px`;
	};

	return (
		<div className="supportIdeas" id={"supIdeas"}>
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="supportIdeas__content">
				<div className="supportIdeas__content_title">
					<h2>We support your ideas</h2>
					{
						width > 1440 ? (
							<span>If you believe you can bring value to our team with
								your ideas and skills, fill out the form to tell us about yourself.
								We review all submissions and contact candidates who stand out.
							</span>
						) : (
							<span>If you believe you can bring value to our team with your ideas
								and skills, fill out the form to tell us about yourself.
							</span>
						)
					}
				</div>
				<form className="supportIdeas__content_form">
					<p>Fill out the form</p>
					<textarea
						ref={aboutTextareaRef}
						value={aboutYourself}
						onChange={(e) => {
							setAboutYourself(e.target.value);
							autoResizeTextarea(e.target);
						}}
						rows={4}
						placeholder={'Tell us about yourself'}
					/>
					<textarea
						ref={ideaTextareaRef}
						value={yourIdea}
						onChange={(e) => {
							setYourIdea(e.target.value);
							autoResizeTextarea(e.target);
						}}
						rows={4}
						placeholder={'Describe your idea'}
					/>
					<div className="supportIdeas__content_form_button">
						<button className="borderButton">
							<span>Suggest an Idea</span>
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default SupportIdeasSection;